import { NgModule } from '@angular/core';

// Pipes
import { WPMediaSize, WPMediaSizeAsync, MimeTypeIcon, NgDatePipeFix, SafeHtmlPipe } from './';

@NgModule({
    declarations: [
        WPMediaSize,
        WPMediaSizeAsync,
        MimeTypeIcon,
        NgDatePipeFix,
        SafeHtmlPipe
    ],
    exports: [
        WPMediaSize,
        WPMediaSizeAsync,
        MimeTypeIcon,
        NgDatePipeFix,
        SafeHtmlPipe
    ],
    providers: [
        WPMediaSize,
        WPMediaSizeAsync,
        MimeTypeIcon,
        NgDatePipeFix,
        SafeHtmlPipe
    ]
})
export class PipesModule {}
